<section aria-labelledby="confirmModalHeaderId" [class]="brand + '-confirm-modal'" class="confirm-password-modal-container">
  <h1 id="confirmModalHeaderId" class="modal-title" tabindex="-1">Confirm Account Changes</h1>
  <form class="styled-form confirm-password-modal-form" name="confirmAccountChangesForm" #ConfirmAccountChangesForm="ngForm" (ngSubmit)="sendPassword()">
    <div class="confirm-password-body">
      <p >Please enter your current password to confirm your changes</p>
      <label for="passwordInput">Current Password</label>
      <div class="password-input-wrapper">
        <input
          [type]="!showPassword ? 'password' : 'text'"
          name="passwordInput"
          id="passwordInput"
          required
          [ngModel]="password"
          (ngModelChange)="password = $event"
          class="form-control"
          autocomplete="off" />
        <label class="sr-only" for="toggle-confirm-password">{{!showPassword ? 'Show password' : 'Hide password'}}</label>
        <button
          type="button"
          [attr.aria-label]="showPassword ? 'Show password' : 'Hide password'"
          id="toggle-confirm-password"
          (click)="toggleShowPassword()">
          @if (!showPassword) {
            <img alt="Show password" src="../../../assets/img/eye.svg" />
          } @else {
            <img alt="Hide password" src="../../../assets/img/eye-slash.svg" />
          }
        </button>
      </div>
    </div>
    <div class="confirm-password-footer">
      <zbp-button-component
        type="button"
        class="text-uppercase"
        label="Cancel"
        theme="ghost"
        (clickHandler)="dismiss()">
      </zbp-button-component>
      <zbp-button-component
        type="submit"
        class="text-uppercase"
        label="Submit"
        theme="primary"
        [disabled]="password.length === 0">
      </zbp-button-component>
    </div>
  </form>
</section>
